<div class="date-filter-input">
  @if (!showDateRangePicker()) {
  <glxy-form-field class="filter-operator-selector" [bottomSpacing]="'none'">
    <mat-select
      [placeholder]="'GALAXY.FILTER.CHIP.SELECT_DATE_DEFAULT_OPTION' | translate"
      [formControl]="dateDefaultControl"
    >
      @for (option of dateDefaultOptions(); track option) {
      <mat-option [value]="option.dateOption">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </glxy-form-field>
  } @if (showDate$ | async) { @if (showDateRangePicker()) {
  <glxy-form-field class="filter-date-range-selector">
    <mat-datepicker-toggle matPrefix [for]="dateRangePicker" />
    <mat-date-range-input [rangePicker]="dateRangePicker">
      <input
        matStartDate
        placeholder="{{'GALAXY.FILTER.CHIP.SELECT_START_PLACEHOLDER' | translate}}"
        [formControl]="startDateControl"
      />
      <input
        matEndDate
        placeholder="{{'GALAXY.FILTER.CHIP.SELECT_END_PLACEHOLDER' | translate}}"
        [formControl]="endDateControl"
      />
    </mat-date-range-input>
    <mat-date-range-picker #dateRangePicker />
  </glxy-form-field>
  } @else {
  <glxy-form-field class="filter-date-selector">
    <input matInput type="date" [formControl]="dateControl" />
  </glxy-form-field>
  } }
</div>
